import { DEFAULT_LOCALE } from 'src/common/constants';

const prependLocale = (path: string, locale?: string): string => {
  if (locale && locale !== DEFAULT_LOCALE) {
    return `/${locale}${path}`;
  }
  return path;
};

export default prependLocale;
